export default {
  $x年中报: '{{x}}年中報',
  $x年年报: '{{x}}年年報',
  '$x季报（累计）': '{{x}}季報（累計）',
  '二季报(累计)': '二季報(累計)',
  '三季报(累计)': '三季報(累計)',
  减持$x: '減持{{x}}',
  减持后剩余$x: '減持後剩餘{{x}}',
  增持$x: '增持{{x}}',
  增持后剩余$x: '增持後剩餘{{x}}',
  $x年: '{{x}}年',
  截至$x: '截至 {{x}}',
  $x更新: '{{x}}更新',
  $y更新: '{{y}}更新',
  净买入$1: '淨買入',
  净买入$2: '淨買入',
  查看更多$2: '查看更多',
  '普通股变动(股)$2': '普通股變動(股)',
  年报$2: '年報',
  中报$2: '中報',
  每股收益$2: '每股收益',
  公司名称$2: '公司名稱',
  除净日$2: '除淨日',
  拆股并股$2: '拆股併股',
  营业利润$2: '營業利潤',
  折旧及摊销$2: '折舊及攤銷',
  净利率$2: '淨利率',
  公布中签$2: '公佈中籤',
  少数股东权益$2: '少數股東權益',
  持股比例$2: '持股比例',
  总负债$2: '總負債',
  认购$2: '認購',
  暗盘$2: '暗盤',
  净利润$2: '淨利潤',
  资产净值$2: '資產淨值',
  资产负债率$2: '資產負債率',
  非控股权益$2: '非控股權益',
  毛利率$2: '毛利率',
  到期日$2: '到期日',
  $x倍: '{{x}}倍',
  $x年$y季度: '{{x}}年{{y}}季度',
  $x年度: '{{x}}年度',
  基金持仓$2: '基金持倉',
  基金规模$2: '基金規模',
  每股指标$2: '每股指標',
  股东权益$2: '股東權益',
  资产$2: '資產',

  现价: '最新價',
  成交额: '成交金額',
  涨跌幅: '升跌幅',
  成交量: '成交股數',

  特大$1: '特大',
  大单$1: '大單',
  中单$1: '中單',
  小单$1: '小單',
  'A 股发行前股本': 'A 股發行前股本',
  '非公开增发 A 股': '非公開增發 A 股',
  送转股: '送轉股',
  激励期权行权: '激勵期權行權',
  可转换债券转股: '可轉換債券轉股',
  股份回购后注销: '股份回購後註銷',
  'A 股上市': 'A 股上市',
  'A 股发行法人配售上市': 'A 股發行法人配售上市',
  三板上市: '三板上市',
  配股上市: '配股上市',
  '增发 A 股上市': '增發 A 股上市',
  '增发 A 股法人配售上市': '增發 A 股法人配售上市',
  股权分置方案实施: '股權分置方案實施',
  股权分置股份追送: '股權分置股份追送',
  股权分置限售流通: '股權分置限售流通',
  股权转让: '股權轉讓',
  其他: '其他',
  股权激励限售流通: '股權激勵限售流通',
  发行前股份限售流通: '發行前股份限售流通',
  无限售不减持承诺到期: '無限售不減持承諾到期',
  '股份性质变动-无限售承诺不减持': '股份性質變動-無限售承諾不減持',
  挂牌交易: '掛牌交易',
  增发变动: '增發變動',
  增发股份限售流通: '增發股份限售流通',
  发行人持股限售流通: '發行人持股限售流通',
  股东增持变动: '股東增持變動'
}
